/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react'
import PropTypes from "prop-types";

export const withTimeCheck = WrappedComponent => (class extends Component {
    /**
     * When the current date is between two dates, this function will return true.
     * If it is not between two dates, or it is out of range from one of the dates, the function will return false.
     * @return {boolean} true if the component should display. false if the component should be hidden.
     */
    shouldDisplay = () => {
        const {until, from, enabled} = this.props;
        if (enabled) return true;

        const now = new Date();
        if (until) {
            if (from) {
                return from >= now <= until;
            }
            return now <= until;
        }
        if (from) {
            return now >= from;
        }
        return true;
    };

    render() {
        return (this.shouldDisplay() ?
                <WrappedComponent {...this.props}/> :
                null
        )
    }
});

withTimeCheck.PropTypes = {
    until: PropTypes.instanceOf(Date),
    from: PropTypes.instanceOf(Date)
};





